import { Injectable, Inject } from '@angular/core';
import { Subject }    from 'rxjs/Subject';
import { Observable } from "rxjs/Observable";

@Injectable()
export class ConnectionPanelsHelperService {

  private Notify = new Subject<any>();
  private Update = new Subject<any>();
  private UpdateUDG = new Subject<any>();
  private SaveBom = new Subject<any>();
  private SaveBomCopy = new Subject<any>();
  panelObservable$ = this.Notify.asObservable();
  updateObservable$ = this.Update.asObservable();
  updateUserDefinedGridObservable$ = this.UpdateUDG.asObservable();
  saveBomObservable$ = this.SaveBom.asObservable();
  saveCopyOfBomObservable$ = this.SaveBomCopy.asObservable();

  public changePanel(data: any) {
    this.Notify.next(data);
  }
  public updatePanel(){
    this.Update.next();
  }
  public updateUserDefinedGrid() {
    this.UpdateUDG.next();
  }
  public saveBom() {
    this.SaveBom.next();
  }
  public saveBomCopy(newSubId: number) {
    this.SaveBomCopy.next(newSubId);
  }
}
